import { applyColorMode, currentColorMode, osColorMode, readColorModeCookie, writeColorModeCookie } from '../shared/color-mode.js';

function isMobileUserAgent() {
    return /Android|iPhone|iPad|iPod|Mobile|Silk|Kindle|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
}

export function initColorModePrompt() {
    if (!isMobileUserAgent() || readColorModeCookie()) {
        return;
    }

    const detectedMode = osColorMode();
    if (!detectedMode || detectedMode === currentColorMode()) {
        return;
    }

    const $modal = $('#colorModePromptModal');
    if (!$modal.length) {
        throw new Error('color-mode-prompt: missing #colorModePromptModal');
    }

    $modal.find('[data-os-color-mode]').text(detectedMode);

    const shouldRemember = () => $modal.find('#colorModePromptRemember').is(':checked');

    $modal.on('click', '[data-color-mode-choice]', function () {
        const mode = this.dataset.colorModeChoice;
        writeColorModeCookie(mode, shouldRemember());
        applyColorMode(mode);
        $modal.modal('hide');
    });

    $modal.on('hidden.bs.modal', function () {
        if (!readColorModeCookie()) {
            writeColorModeCookie(currentColorMode(), shouldRemember());
        }
    });

    $modal.modal('show');
}
